<template>
    <div>
        <button class="info-terms__prev" @click.prevent="goBack">
            <Icon name="arrow-left" />
        </button>
    </div>
    <div class="info-terms">
        <p>Если у вас есть вопросы, идеи или проблемы, мы всегда рады помочь! Напишите нам на почту: support@flirtby.blog. Наша команда поддержки ответит вам в кратчайшие сроки. Мы стремимся сделать ваш опыт общения на нашем сайте максимально комфортным и приятным!</p>
        <b>support@flirtby.blog</b>
    </div>
</template>

<script setup>
const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss">
body:has(.info-terms) {
    background: #101214;
    color: #fff;
}
.info-terms {
    padding-bottom: 2rem;
    *:not(:last-child) {
        margin-bottom: 1rem;
    }

    &__prev {
        font-size: 36px;
        padding: 15px 15px 15px 0;
    }
}
</style>